import { createTheme } from "@mui/material/styles";
let base = createTheme(); // Used for breakpoints, so it needs to be a v5 theme too

// A custom theme for this app
const theme = createTheme({
  spacing: 10,
  typography: {
    fontFamily: [
      "Montserrat",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#FF6A14",
      contrastText: "#fff",
    },
    secondary: {
      main: "#1faa00",
    },
    /* error: {
      main: red.A400
    },*/
    background: {
      default: "#F8F9FA",
    },
    mode : "light" // 'type' is deprecated, use 'mode' instead
  },
  components: { // 'overrides' is deprecated, use 'components'
    MuiButton: { // Component name
      styleOverrides: { // Style sheet name ⚛️
        root: { // Rule name
          borderRadius: 4,
          boxShadow: "none",
          // 'textTransform: capitalize' is default for MUI v5 buttons, so often not needed
          "&.Mui-disabled": { // Targeting disabled state
            boxShadow: "none",
          },
        },
        contained: { // Rule name for contained variant
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 3,
          [base.breakpoints.down("md")]: {
            height: 2,
          },
          [base.breakpoints.up("md")]: {
            height: 3,
          },
        },
      },
    },
    MuiBackdrop: { // Component name
      styleOverrides: {
        root: { /*zIndex: 8000,*/ },
      },
    },
    MuiPaper: { // Component name
      styleOverrides: {
        rounded: { borderRadius: 8, },
      },
    },
    MuiSnackbar: { // Component name
      styleOverrides: { // Style sheet name ⚛️
        root: { // Rule name
          zIndex: '9999',
        },
      },
    },
  },
});
//boxShadow: "0px 1px 0px ",
//theme.shadows[0] = "0px 0px 0px 1px #DDE0E5";
theme.shadows[10] = "0px 0px 0px 1px #DDE0E5";
theme.shadows[2] =
  "0px 3px 1px -2px rgba(0,0,0,0.06),0px 2px 2px 0px rgba(0,0,0,0.06),0px 1px 5px 0px rgba(0,0,0,0.06)";
theme.shadows[1] =
  "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)";
theme.shadows[6] = "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.06),0px 1px 18px 0px rgba(0,0,0,0.06)";
//  theme.shadows[1] = "0px 2px 1px -1px rgba(0,0,0,0.06),0px 1px 1px 0px rgba(0,0,0,0.06),0px 1px 3px 0px rgba(0,0,0,0.06)";

export default theme;
